import React, { useState, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import GlassTypesTab from './GlassTypesTab';
import EstimateTab from './EstimateTab';
import SavedEstimatesTab from './SavedEstimatesTab';
import { EstimateProvider } from '@/contexts/EstimateContext';
import { useToast } from '@/hooks/use-toast';
import TutorialSlideShow from './TutorialSlideShow';
import SharedLayout from './SharedLayout';

const Layout: React.FC = () => {
  const { toast } = useToast();
  const [showTutorial, setShowTutorial] = useState(false);

  // Check if this is the first time the user is visiting the app
  useEffect(() => {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore');
    if (!hasVisitedBefore) {
      // Set a flag in localStorage to indicate the user has visited before
      localStorage.setItem('hasVisitedBefore', 'true');
      // Show the tutorial automatically on first visit
      setShowTutorial(true);
    }
  }, []);
  return (
    <SharedLayout showTutorial={() => setShowTutorial(true)}>
      {/* Tutorial Slideshow */}
      <TutorialSlideShow open={showTutorial} onOpenChange={setShowTutorial} />

      <Tabs defaultValue="estimate" className="w-full">
        <TabsList className="grid grid-cols-3 mb-8 bg-secondary/50 backdrop-blur-sm">
          <TabsTrigger value="estimate" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground transition-all duration-500">Estimate</TabsTrigger>
          <TabsTrigger value="glassTypes" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground transition-all duration-500">Glass Types & Pricing</TabsTrigger>
          <TabsTrigger value="savedEstimates" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground transition-all duration-500">Saved Estimates</TabsTrigger>
        </TabsList>

        <EstimateProvider>
          <TabsContent
            value="estimate"
            className="transition-all duration-800 ease-in-out animate-fade-in motion-reduce:animate-none w-full"
            style={{ transform: 'translateZ(0)' }}
          >
            <EstimateTab />
          </TabsContent>

          <TabsContent
            value="glassTypes"
            className="transition-all duration-800 ease-in-out animate-fade-in motion-reduce:animate-none w-full"
            style={{ transform: 'translateZ(0)' }}
          >
            <GlassTypesTab />
          </TabsContent>

          <TabsContent
            value="savedEstimates"
            className="transition-all duration-800 ease-in-out animate-fade-in motion-reduce:animate-none w-full"
            style={{ transform: 'translateZ(0)' }}
          >
            <SavedEstimatesTab />
          </TabsContent>
        </EstimateProvider>
      </Tabs>

      <footer className="mt-12 text-center text-sm text-muted-foreground">
        <p>&copy; 2025 ServicePane. All rights reserved.</p>
      </footer>
    </SharedLayout>
  );
};

export default Layout;
